import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { UIService } from '../../core/services/utils/ui.service';
import { AuthService } from '../../core/services/auth/auth.service';
import { ScreensStateService } from '../../core/services/screen-state/screens-state.service';
import { PlaylistsService } from '../../core/services/http-services/playlists.service';

import { PlaylistDTO } from '../../core/models/view-models/playlist-models/playlist-dto.model';
import { TagViewModel } from './../../core/models/view-models/tag-models/tag-view.model';
import { LibraryEditItemTypeEnum } from './../../core/enums/library-edit-item-type.enum';
import { SortEnum } from '../../core/enums/playlist-sort.enum';

@Component({
  selector: 'library',
  templateUrl: './library.component.html',
  styleUrls: ['./library.component.scss'],
})
export class LibraryComponent implements OnDestroy {
  playlistSortingModes = SortEnum;
  playlistSortingMode = SortEnum.SortByDateCreated;
  libraryEditItemTypes = LibraryEditItemTypeEnum;
  isBottomPanelVisible: boolean;

  globalPlaylists: PlaylistDTO[] = [];
  localPlaylists: PlaylistDTO[] = [];
  androidPlaylists: PlaylistDTO[] = [];
  sharedPlaylists: PlaylistDTO[] = [];
  availableConnectedIds: string[] = [];

  private subscriptions: Subscription = new Subscription();

  constructor(
    private readonly uiService: UIService,
    private readonly playlistDataService: PlaylistsService,
    private readonly screensStateService: ScreensStateService,
    private readonly authService: AuthService
  ) {
    this.initSubscriptions();
  }

  get ui(): UIService {
    return this.uiService;
  }

  get selectedScreensState() {
    return this.screensStateService.getScreensState();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  createNewItem(itemType: LibraryEditItemTypeEnum): void {
    switch (itemType) {
      case LibraryEditItemTypeEnum.EditPlaylist:
        this.uiService.showLibraryEditPanel(
          new PlaylistDTO(),
          LibraryEditItemTypeEnum.EditPlaylist
        );
        break;

      case LibraryEditItemTypeEnum.EditTag:
        this.uiService.showLibraryEditPanel(
          new TagViewModel(),
          LibraryEditItemTypeEnum.EditTag
        );
        break;
    }
  }

  togglePlaylistPanel(value: boolean): void {
    this.ui.isPlaylistPanelExpanded = value;
  }

  toggleTagPanel(value: boolean): void {
    this.ui.isTagsPanelExpanded = value;
  }

  private initSubscriptions(): void {
    this.subscriptions.add(
      this.screensStateService.screensCollectionChanged.subscribe(
        (data) => {
          if (data) {
            this.availableConnectedIds = data.map((x) => x.MonitorHandler);
          }
        }
      )
    );

    this.subscriptions.add(
      this.uiService.bottomPanelVisibleSubject.subscribe(
        (data) => setTimeout(() => { this.isBottomPanelVisible = data; })
      )
    );

    this.subscriptions.add(
      this.playlistDataService.playlistCollectionChanged.subscribe((data) =>
        this.groupPlaylists(data)
      )
    );
  }

  private groupPlaylists(playlists: PlaylistDTO[]): void {
    this.sharedPlaylists = [];
    this.localPlaylists = [];
    this.globalPlaylists = [];
    this.androidPlaylists = [];

    playlists.forEach((playlist) => {
      if (this.authService.userId !== playlist.UserId) {
        this.sharedPlaylists.push(playlist);
      } else if (playlist.IsAndroid) {
        this.androidPlaylists.push(playlist);
      } else if (playlist.MachinePhysicalAddress) {
        this.localPlaylists.push(playlist);
      } else {
        this.globalPlaylists.push(playlist);
      }
    });
  }
}
